import { TransactionsApiBase } from './paymentApi';

class TransactionApi extends TransactionsApiBase {
}

export default new TransactionApi();
